import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
export const getCustomers = createAsyncThunk(
  "/PaymentLink/control-customer-list",
  async ({ params }, { rejectWithValue }) => {
    try {
   
      const data = await commonNetwork.post("/control-customer-list-v1", params);

      if (data.isSuccess) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e) {
      return rejectWithValue(e.data.message);
    }
  }
);
const limit = 10;

export const customerListSlice = createSlice({
  name: "customerlist",
  initialState: {
    customers: [],
    selectedAmountType: 1,
    totalPage: 1,
    currentPage: 1,
    limit: 10,
    totalRecords: 0,
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
    isfetchComplete : false
  },
  reducers: {
    clearState: (state) => {
      state.customers = [];
      state.totalPage = 1;
      state.currentPage = 1;
      state.limit = 10;
      state.totalRecords = 0;
      state.isfetchComplete= false;
      return state;
    },
    updateField: (state, action) => {

      var objects = Object.getOwnPropertyNames(action.payload);

      var index = state.customers.findIndex(w => w.customercode == action.payload.customercode);

      if (index != -1) {
        for (let i = 0; i < objects.length; i++) {
          const element = objects[i];
          state.customers[index][element] = action.payload[element];
        }
      }
      return state;
    }, 
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomers.fulfilled, (state, { payload }) => {

      var responseData=payload.data;
      var customers = responseData.customers;
      

      state.customers = customers;
      state.selectedAmountType = responseData.selectedAmountType;
      state.currentPage = payload.currentPage;
      state.totalPage = state.customers.length / limit;
      state.limit = limit;
      state.totalRecords = state.customers.length;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      state.isfetchComplete= true;
      return state;
    });
    builder.addCase(getCustomers.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      // state.errorMessage = payload.message;
    });
    builder.addCase(getCustomers.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState, updateField } = customerListSlice.actions;

export const customerListSelector = (state) => state.customerlist;

export const customerListReducer = customerListSlice.reducer;
